export interface Interval<T> {
    start: T;
    end: T;
}

export enum ViewMode {
    Day,
    Week,
    Month,
    SixMonth,
}

export function isViewMode(x: string): x is keyof typeof ViewMode {
    return x in ViewMode;
}
